/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Else, If, Then } from "react-if";
import { Box, FlexContainer, Table, Text, theme } from "@nordcloud/gnui";
import { LoaderWrap, NoData } from "~/components";
import { StyledTh } from "~/components/Tables/styles";
import { isEmpty } from "~/tools";
import { useGetDistinctPatchFailures } from "../../hooks";
import { DistinctUpdateFailuresRow } from "./DistinctUpdateFailuresRow";
import { DistinctUpdateFailuresSkeleton } from "./DistinctUpdateFailuresSkeleton";

export function DistinctUpdateFailures() {
  const { failures, loading } = useGetDistinctPatchFailures();

  return (
    <Box
      padding={theme.spacing.spacing04}
      css={{ display: "flex", flexDirection: "column", flex: 1 }}
    >
      <Text weight="medium" mb={theme.spacing.spacing00}>
        Distinct update failures
      </Text>
      <Text
        size="sm"
        color={theme.color.text.text02}
        mb={theme.spacing.spacing02}
      >
        Last 6 months
      </Text>
      <If condition={!loading && isEmpty(failures)}>
        <Then>
          <NoData
            message="No update failures in the last 6 months."
            customCss={{ flex: 1, marginBottom: theme.spacing.spacing07 }}
          />
        </Then>
        <Else>
          <Table small>
            <Table.thead>
              <Table.tr>
                <StyledTh css={{ cursor: "default" }} />
                <StyledTh css={{ cursor: "default" }}>Resource Name</StyledTh>
                <StyledTh css={{ cursor: "default", whiteSpace: "nowrap" }}>
                  <FlexContainer
                    css={{ width: "100%" }}
                    justifyContent="flex-start"
                  >
                    Failed Actions
                  </FlexContainer>
                </StyledTh>
              </Table.tr>
            </Table.thead>
            <Table.tbody>
              <LoaderWrap
                loading={loading}
                Component={DistinctUpdateFailuresSkeleton}
              >
                {failures.map((failure) => (
                  <DistinctUpdateFailuresRow
                    key={failure.resourceId}
                    failure={failure}
                  />
                ))}
              </LoaderWrap>
            </Table.tbody>
          </Table>
        </Else>
      </If>
    </Box>
  );
}
